import { createSelector } from '@ngrx/store';
import { getOneClickSelectedOrder } from './one-click-orders.selector';
import { getLegalEntity } from '@cemex/cmx-client-layout';
import { CountryCodesType } from '@cemex-core/cmx-api';
import { PRODUCT_LINE_CODE } from '../../shared/constants/product-lines-codes';
import { ShippingConditionsCodesTypes } from '@cemex-core/cmx-api/models/shipping-conditions/shipping-conditions-codes';
import { getOneClickShippingMethodSelected } from './one-click-shipping-methods.selector';
import { getOneClickShippingLocationModeSelected } from './one-click-shipping-location-modes.selector';
import { getOneClickBusinessLinesSelected } from '@ordersnproducts/modules/one-click-order/selectors/one-click-business-lines.selector';
import { getOneClickPreloadedOrder } from '@ordersnproducts/modules/one-click-order/selectors/one-click-profiles.selector';

export const getOneClickConfigParams = createSelector(
  getLegalEntity,
  getOneClickSelectedOrder,
  (customer, selectedOrder) => {
    return {
      countryCode: customer.countryCode as CountryCodesType,
      businessLine:
        selectedOrder &&
        selectedOrder.items &&
        (selectedOrder.items[0].product.productType.productTypeCode as PRODUCT_LINE_CODE),
      shippingConditionCode:
        selectedOrder &&
        selectedOrder.shippingCondition &&
        (selectedOrder.shippingCondition.shippingConditionCode as ShippingConditionsCodesTypes),
    };
  },
);

export const getOneClickBuilderShippingModeParams = createSelector(
  getLegalEntity,
  getOneClickBusinessLinesSelected,
  getOneClickShippingMethodSelected,
  getOneClickPreloadedOrder,
  (customer, businessLine, shippingMethod, orderPreselected) => ({
    countryCode: customer.countryCode,
    productLineCode: businessLine
      ? businessLine.productLineCode
      : orderPreselected.items[0].product.productType.productTypeCode,
    shippingMethodCode: shippingMethod && shippingMethod.shippingConditionCode,
  }),
);

export const getOneClickBuilderParams = createSelector(
  getLegalEntity,
  getOneClickBusinessLinesSelected,
  getOneClickShippingMethodSelected,
  getOneClickShippingLocationModeSelected,
  getOneClickPreloadedOrder,
  (customer, businessLine, shippingMethod, shippingLocationMode, orderPreselected) => ({
    countryCode: customer.countryCode,
    productLineCode: businessLine
      ? businessLine.productLineCode
      : orderPreselected.items[0].product.productType.productTypeCode,
    shippingMethodCode: shippingMethod && shippingMethod.shippingConditionCode,
    shippingLocatonModeCode: shippingLocationMode && shippingLocationMode.code,
  }),
);
